<template>
  <eco-labeled-control :context="contextV2" :attributes="attributes" class="ignore-in-charts-control">
    <v-tooltip bottom>
      <base-checkbox slot="activator" 
        :value="device.isIgnoredInCharts"
        :disabled="isInteracted"
        @buttonToggled="onChecked"
      />
      <span>{{ 'parameter.ignoreincharts' | translate }}</span>
    </v-tooltip>
  </eco-labeled-control>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import { DeviceModel, SetDeviceIgnoreInChartsInput } from '../../../../../../../eco-domain-store-modules/src/plcOperation/models'

import { EcoLabeledControl } from '@ecocoach/shared-components/src'
import { BaseControlAttributes, ControlContextV2 } from '@ecocoach/shared-components/src/components/deviceControls/v2/models'

const Resource = namespace('resource')
const ParametrizationUi = namespace('parametrizationUi')

@Component({
  components: {
    EcoLabeledControl,
  },
})
export default class IgnoreInCharts extends Vue {
  @Prop() public device: DeviceModel
  @Resource.Getter public dictionary
  @ParametrizationUi.Getter public isInteracted: boolean
  @ParametrizationUi.Action public setDeviceIgnoreInCharts: (input: SetDeviceIgnoreInChartsInput) => Promise<void>

  public get contextV2(): ControlContextV2 {
    return {
      resolveStringResource: (resourceKey: string): string => {
        return this.dictionary(resourceKey)
      },
    } as ControlContextV2
  }

  public get attributes() {
    return {
      label: 'parameter.ignoreincharts',
      tooltip: 'parameter.ignoreincharts.label',
    } as BaseControlAttributes
  }

  public onChecked(enabled: string) {
    this.setDeviceIgnoreInCharts({
      deviceId: this.device.id,
      ignoreInCharts: !enabled,
    } as SetDeviceIgnoreInChartsInput)
  }
}
</script>
<style lang="scss" scoped>
.ignore-in-charts-control {
  padding-bottom: 15px;
}
</style>
